<template>
  <div class="login">
    <h1 class="center-text">Login to Your Account</h1>
    <form @submit.prevent="login">
      <div class="form-300 center-element">
        <div v-if="apiError" class="error form-300">
          Error: {{ apiErrorMessage }}<br />
        </div>
        <label>Email</label><br />
        <input
          ref="emailField"
          v-model.trim="user.email"
          type="text"
          autocomplete="email"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <label>Password</label><br />
        <input
          ref="passwordField"
          v-model.trim="user.password"
          type="password"
          autocomplete="password"
          placeholder="Password"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Password'"
          required
        /><br />
        <button type="submit" class="button button-300">Login</button>
        <br /><br />
        <h4 class="center-text">
          <router-link :to="{ path: '/console/forgotpassword' }"
            >Forgot Password?</router-link
          >
        </h4>
        v1.0.13
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data() {
    return {
      user: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    // loginError () {
    //   return this.$store.getters.loginAPIError;
    // },
    apiError() {
      return this.$store.getters.apiError;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    }
  },
  created() {
    // this.$store.commit('setLoginAPIError', false);
    this.$store.dispatch("resetAllAPIErrorAndMessages");
  },
  methods: {
    login: function() {
      this.$store.dispatch("resetAllAPIErrorAndMessages");
      // this.$store.commit('setLoginAPIError', false);
      if (this.user.email && this.user.password) {
        this.$store.dispatch("login", this.user);
      }
    }
  }
};
</script>
<style></style>
